import React, { useState } from 'react';
import { Heart } from 'lucide-react';

const Logo = ({ 
  size = 'md', 
  showFallback = true, 
  className = '',
  alt = 'Bubbles & Bark Logo' 
}) => {
  const [imageError, setImageError] = useState(false);
  const [currentSrc, setCurrentSrc] = useState(0);
  
  const sizeClasses = {
    sm: 'w-10 h-10',
    header: 'w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14',
    md: 'w-16 h-16 md:w-20 md:h-20',
    lg: 'w-20 h-20 md:w-24 md:h-24'
  };

  const logoSources = [
    './Bubbles-Bark-01.png',
    '/Bubbles-Bark-01.png',
    `${process.env.PUBLIC_URL}/Bubbles-Bark-01.png`
  ];

  const handleImageError = () => {
    console.log(`Logo failed to load from: ${logoSources[currentSrc]}`);
    if (currentSrc < logoSources.length - 1) {
      setCurrentSrc(currentSrc + 1);
    } else {
      setImageError(true);
    }
  };

  if (imageError && !showFallback) {
    return null;
  }

  return (
    <div 
      className={`${sizeClasses[size]} rounded-full overflow-hidden shadow-lg bg-white border-2 border-pink-200 ${className}`} 
      aria-label={alt}
    >
      {!imageError ? (
        <img 
          src={logoSources[currentSrc]}
          alt={alt}
          className="w-full h-full object-contain p-1"
          onError={handleImageError}
          onLoad={() => console.log(`Logo loaded successfully from: ${logoSources[currentSrc]}`)}
          loading="lazy"
        />
      ) : showFallback ? (
        <div className="w-full h-full bg-gradient-to-r from-pink-500 to-cyan-400 rounded-full flex items-center justify-center">
          <Heart className={`${size === 'sm' ? 'w-4 h-4' : size === 'lg' ? 'w-10 h-10' : 'w-7 h-7'} text-white`} aria-hidden="true" />
        </div>
      ) : null}
    </div>
  );
};

export default Logo;